import React from "react";
import { Helmet } from "react-helmet-async";
import { SEO, OG_IMAGE, BRAND, abs } from "@/data/seo";

/**
 * Per-route SEO head manager (react-helmet-async).
 * Emits exactly one title, meta description, canonical, OG + Twitter tags,
 * a robots directive, and optional JSON-LD structured data.
 */
export const Seo = ({ path, title, description, noindex = false, image, jsonLd }) => {
  const cfg = (path && SEO[path]) || {};
  const finalTitle = title || cfg.title || `${BRAND} — The payment trust layer for service businesses`;
  const finalDesc = description || cfg.description || "";
  const canonical = abs(path || "/");
  const ogImage = image || OG_IMAGE;
  const robots = noindex ? "noindex, nofollow" : "index, follow";

  return (
    <Helmet prioritizeSeoTags>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDesc} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={BRAND} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDesc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDesc} />
      <meta name="twitter:image" content={ogImage} />

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

export default Seo;
